import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginHomeView from '../views/LoginHomeView.vue'
Vue.use(VueRouter)
Vue.config.productionTip = false
// 解决重复导航错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
		path: '/',
		name: 'home',
		component: HomeView,
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/LoginHomeView',
		name: 'LoginHomeView',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: LoginHomeView,
		meta: {
		      keepAlive: false // 需要缓存的页面
		    },
		children: [,
			{
				path: '/userInfo', // 待办事项
				name: 'userInfo',
				component: () => import('../views/userInfo.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/working', // 待办事项
				name: 'working',
				component: () => import('../views/nworking.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/zjz', // 待办事项
				name: 'zjz',
				component: () => import('../views/nzjz.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/Todo', // 待办事项
				name: 'Todo',
				component: () => import('../views/Todo.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/immediate-match', // 即时撮合
				name: 'ImmediateMatch',
				component: () => import('../views/ImmediateMatch.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/person-search', // 人员检索
				name: 'PersonSearch',
				component: () => import('../views/PersonSearch.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/job-search', // 岗位检索
				name: 'JobSearch',
				component: () => import('../views/JobSearch.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/personnel-demand', // 人员需求管理
				name: 'PersonnelDemand',
				component: () => import('../views/PersonnelDemand.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '/personnel-redundancy', // 人员冗余管理
				name: 'PersonnelRedundancy',
				component: () => import('../views/PersonnelRedundancy.vue'),
				meta: {
				      keepAlive: false // 需要缓存的页面
				    },
			},
			{
				path: '',
				redirect: '/userInfo' // 默认重定向到待办事项
			}
		]
	},
	{
		path: '/about',
		name: 'about',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/AboutView.vue'),
		meta: {
		      keepAlive: false // 需要缓存的页面
		    },
	},
	{
		path: '/news',
		name: 'news',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/newsView.vue'),
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/news1',
		name: 'news1',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news1View.vue'),
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/news2',
		name: 'news2',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news2View.vue'),
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/news3',
		name: 'news3',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news3View.vue'),
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/news4',
		name: 'news4',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news4View.vue'),
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/news5',
		name: 'news5',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news5View.vue'),
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/news6',
		name: 'news6',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/news6View.vue'),
		meta: {
			keepAlive: true // 需要缓存
		}
	},
	{
		path: '/nrck',
		name: 'nrck',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nrck.vue'),
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/nrckDetail',
		name: 'nrckDetail',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nrckDetail.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/nrcxq',
		name: 'nrcxq',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nrcxq.vue'),
		meta: {
		      keepAlive: true // 需要缓存的页面
		    },
	},
	{
		path: '/nrcxqdetail',
		name: 'nrcxqdetail',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nrcxqdetail.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/ngwxqdetail',
		name: 'ngwxqdetail',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/ngwxqdetail.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/ngwxq',
		name: 'ngwxq',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/ngwxq.vue'),
		meta: {
		        keepAlive: true // 需要缓存
		      }
	},
	{
		path: '/nxmxq',
		name: 'nxmxq',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nxmxq.vue'),
		meta: {
			keepAlive: true // 需要缓存的页面
		},
	},
	{
		path: '/nxmxqdetail',
		name: 'nxmxqdetail',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/nxmxqdetail.vue'),
		meta: {
			keepAlive: false // 需要缓存
		}
	},
	{
		path: '/shareMatchResult',
		name: 'shareMatchResult',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( '../views/shareMatchResult.vue'),
		meta: {
		    keepAlive: true // 需要缓存
		}
	},
	{
		path: '/store',
		name: 'store',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/storeView.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/dishes',
		name: 'dishes',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/dishesView.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/shop',
		name: 'shop',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/ShopListView.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/connectUs',
		name: 'connectUs',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/ConnectUsView.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/brandIntroduction',
		name: 'brandIntroduction',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/BrandIntroduction.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/PolicyNewsDetail',
		name: 'PolicyNewsDetail',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/PolicyNewsDetail.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
	  path: '/JobDetail',
	  name: 'JobDetail',
	  // route level code-splitting
	  // this generates a separate chunk (about.[hash].js) for this route
	  // which is lazy-loaded when the route is visited.
	  component: () => import(/* webpackChunkName: "about" */ '../views/JobDetail.vue'),
	  meta: {
	        keepAlive: false // 需要缓存的页面
	      },
	},
	{
		path: '/Login',
		name: 'Login',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Login.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/Register',
		name: 'Register',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/Register.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	},
	{
		path: '/ForgetPassword',
		name: 'ForgetPassword',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import( /* webpackChunkName: "about" */ '../views/ForgetPassword.vue'),
		meta: {
		        keepAlive: false // 需要缓存
		      }
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})
// 全局路由守卫
// router.beforeEach((to, from, next) => {
// 	// 检查用户是否已登录
// 	const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true'

// 	console.log('=== 路由守卫调试信息 ===')
// 	console.log('目标路径:', to.path)
// 	console.log('是否已登录:', isLoggedIn)
// 	console.log('localStorage.isLoggedIn:', localStorage.getItem('isLoggedIn'))

// 	// 记录用户访问的页面（除了登录页）
// 	if (to.path !== '/Login') {
// 		localStorage.setItem('lastVisitedPage', to.path)
// 	}

// 	// 已登录但访问登录页，跳转到首页
// 	if (to.path === '/Login' && isLoggedIn) {
// 		console.log('已登录，从登录页跳转到首页')
// 		next('/')
// 		return
// 	}

// 	// 访问首页但未登录，跳转到登录页
// 	if (to.path === '/' && !isLoggedIn) {
// 		console.log('未登录，从首页跳转到登录页')
// 		next('/Login')
// 		return
// 	}

// 	// 其他情况正常访问
// 	console.log('正常访问:', to.path)
// 	next()
// })
export default router